import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Oncology = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.783 36.945c0-.1-.1-.2-.1-.3l-6.105-8.01c3.202-4.406 4.904-9.612 4.904-15.019 0-1.601-.1-3.804-.4-5.406C31.88 3.404 27.275 0 21.971 0c-5.905 0-10.91 4.405-11.21 10.012-.7 6.608.701 13.216 4.705 18.623l-6.106 8.01c-.3.4-.2.9.1 1.3l6.206 5.808c.4.4 1.2.3 1.501-.2l4.804-6.308 4.804 6.308c.3.5 1 .6 1.501.2l6.205-5.807c.3-.2.4-.6.3-1.001ZM21.972 1.902c4.304 0 7.907 2.704 9.008 6.308l-2.402 3.204c-3.604-4.205-9.608-4.205-13.211 0L12.963 8.21c1.101-3.604 4.704-6.308 9.008-6.308Zm5.404 11.114-5.404 7.008-5.405-7.008c3.203-3.805 7.707-3.705 10.81 0Zm-6.605 8.61-4.103 5.407c-3.003-4.406-4.404-9.512-4.104-14.718l.1-1.402 1.902 2.503 6.205 8.21ZM16.267 41.65l-4.804-4.505c5.405-7.109 12.61-16.62 18.015-23.729l1.902-2.503.1 1.402a24.035 24.035 0 0 1-4.804 15.719L16.267 41.65Zm11.41 0-4.504-6.007 4.103-5.407 5.205 6.909-4.804 4.505Z"
  }));
});
Oncology.displayName = 'Oncology';
Oncology.defaultProps = {
  'aria-label': 'Oncology'
};
export default Oncology;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/Oncology.js
// module id = 3677
// module chunks = 11